module.exports = __webpack_public_path__ + "media/images/video-square-black-94e11ac0.svg";